module.exports = __webpack_public_path__ + "img/43.a43b986a.jpg";